import { SafetyCertificateOutlined, SettingOutlined, TeamOutlined } from "@ant-design/icons";


export const getSettingsModuleIcon = (iconKey) => {
  switch (iconKey) {
    case "accounts":
      return <TeamOutlined />;
    case "security":
      return <SafetyCertificateOutlined />;
    case "configuration":
    default:
      return <SettingOutlined />;
  }
};
